import { Flex, Typography } from "antd"

import Icon from "../../../../../Icon"

const { Text } = Typography

const serviceName = {
  ethoca: "Ethoca",
  rdr: "RDR",
  cdrn: "CDRN"
}

const DescriptorsEmpty = ({ service, isFiltered }) => {
  return (
    <Flex justify="center" align="center" className="descriptor-list-empty-state" gap={16} vertical>
      <Icon className="empty-list-icon" type="inbox_empty_filled" />
      {!isFiltered && (
        <Flex vertical gap={8} justify="center" className="text">
          <Text className="empty-title">You haven’t enrolled any billing descriptors yet</Text>
          <Text type="secondary">
            Add a billing descriptor to start receiving {serviceName[service]} alerts.
          </Text>
        </Flex>
      )}
      {isFiltered && <Text className="empty-title">No descriptors found</Text>}
    </Flex>
  )
}

export default DescriptorsEmpty
